import { useEffect, useState } from "react";
import { api, COMPANY } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Tag, Phone } from "lucide-react";
import { onCallClick } from "@/lib/dialer";

const FALLBACK = [
  { id: "s1", title: "Seasonal AC Tune-Up", description: "Pre-summer inspection, refrigerant check, coil clean.", discount: "Save up to $40" },
  { id: "s2", title: "New System Installation", description: "Free in-home consultation + flexible financing.", discount: "0% APR available" },
  { id: "s3", title: "Maintenance Plan", description: "Priority service and member-only repair pricing.", discount: "Members save 10%" },
];

export default function Specials() {
  const { t } = useLang();
  const [items, setItems] = useState(FALLBACK);
  useEffect(() => { api.get("/specials").then(r => { if (r.data?.length) setItems(r.data); }).catch(()=>{}); }, []);

  return (
    <section id="specials" className="section-pad" data-testid="specials">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">Limited Time</div>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-black">{t("specials.title")}</h2>
        <p className="mt-3 text-silver-300 max-w-2xl">{t("specials.sub")}</p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((s, i) => (
            <div key={s.id||i} className="card-ink rounded-2xl p-6 relative overflow-hidden" data-testid={`special-${i}`}>
              <div className="absolute -top-10 -right-10 size-32 rounded-full bg-ice-400/10 blur-2xl"/>
              <div className="size-11 rounded-xl bg-ice-400/15 ring-1 ring-ice-400/30 grid place-items-center"><Tag className="size-5 text-ice-400"/></div>
              <h3 className="mt-4 font-display text-lg font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm text-silver-300">{s.description}</p>
              {s.discount && <div className="mt-4 inline-flex items-center gap-2 rounded-full px-3 py-1 ring-1 ring-ice-400/40 text-ice-400 text-xs font-semibold">{s.discount}</div>}
              <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="mt-5 btn-primary rounded-full px-4 py-2 text-sm flex items-center gap-2 w-fit" data-testid={`special-claim-${i}`}>
                <Phone className="size-4"/> Claim Offer
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
